import { FileType } from 'src/types/file';
import getFileData from 'src/utils/getFileData';

const base64MimeType: any = (encoded: string) => {
    let result = null;

    if (typeof encoded !== 'string') {
        return result;
    }

    const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

    if (mime && mime.length) {
        result = mime[1];
    }

    return result;
};

export interface FormatedFileType {
    data: string | undefined;
    fileType: string | undefined;
    width: string;
}
export type FormatFileType = (fileData: FileType) => FormatedFileType;

export const formatFile: FormatFileType = (fileData) => {
    let { fileType, data, directUrl } = fileData;
    let width = '';

    if (!fileType) {
        fileType = base64MimeType(data);
    }

    if (fileType === 'pdf' || fileType === 'PDF') {
        fileType = 'application/pdf';
    }

    if (data && !directUrl) {
        if (data.indexOf('data:') !== 0) {
            data = `data:application/pdf;base64,${data}`;
            fileType = 'application/pdf';
        }

        if (data.indexOf('data:PDF') === 0) {
            data = data.replace('data:PDF', 'data:application/pdf');
            fileType = 'application/pdf';
        }

        // if (data.indexOf('data:image;base64') === 0) {
        if (data.indexOf('data:image') === 0) {
            fileType = 'image';
        }
    }

    if (fileType === 'application/pdf') {
        width = '100%';
    }

    return { data, fileType, width };
};

export const downloadFile = async (fileData: FileType, custonName?: string) => {
    const extendFileData = { ...fileData };
    if (!extendFileData.data && extendFileData.id) {
        extendFileData.data = await getFileData(extendFileData.id);
    }

    const { data, fileType } = formatFile(extendFileData);
    if (data && fileType) {
        const element = document.createElement('a');
        element.download = custonName || extendFileData.name || extendFileData.fileName || 'file';
        element.href = data;
        element.type = fileType;
        element.click();
        element.remove();
    }
};
